/*
  Convert velocity into velocity per second
*/
/*#__NO_SIDE_EFFECTS__*/
const velocityPerSecond = (velocity, frameDuration) => frameDuration ? velocity * (1000 / frameDuration) : 0;

export { velocityPerSecond };
//# sourceMappingURL=velocity-per-second.mjs.map
